import {BASE_URL} from 'appConstants';

import {get, post} from 'sdk';

export const fetchAgreementUser = ({agreementUserId}) => {
  const url = `${BASE_URL}/v1/living/agreement-user/${agreementUserId}/`;
  return get(url);
};

export const updateAgreementUser = ({
  agreementUserId,
  fullName,
  email,
  phone,
  gender,
  birthday,
  nationality,
  countryCode,
  countryOfOrigin,
  location
}) => {
  const url = `${BASE_URL}/v1/living/agreement-user/${agreementUserId}/update/`;
  const payload = {
    fullName,
    email,
    phone,
    gender,
    birthday,
    nationality,
    countryCode,
    countryOfOrigin,
    location
  };

  return post(url, payload);
};

export const signAgreementUserInternalAvatar = ({
  filename,
  fileType,
  owner,
  agreementUserId,
  location
}) => {
  const url = `${BASE_URL}/v1/living/agreement-user/${agreementUserId}/internal-avatar-sign/`;
  const payload = {filename, fileType, owner, location};

  return post(url, payload);
};

export const verifyAgreementUserInternalAvatarUpload = ({
  identifier,
  agreementUserId
}) => {
  const url = `${BASE_URL}/v1/living/agreement-user/${agreementUserId}/internal-avatar-verify-upload/`;
  const payload = {
    identifier
  };

  return post(url, payload);
};
